import React from "react"
import { css } from "@emotion/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { color } from "../defaults/styles/theme"
import { IconButton, IconButtonOff } from "../defaults/styles/elements"
import DownloadIcon from "../defaults/assets/svg/download.svg"
import Calendar from "../defaults/assets/svg/calendar.svg"
import Clock from "../defaults/assets/svg/clock.svg"
import { People } from "../defaults/assets/svg/mobilenav"
import Mail from "../defaults/assets/svg/mail.svg"
import moment from "moment"
import ExpoLogo from "../defaults/assets/logos/expo9_pri_wht_rgb.svg"
import mq from "../defaults/styles/mediaquerys"
import passLockFilter from "../defaults/filters/passLockFilter"
import recordFilter from "../defaults/filters/record"
import Flags from "../../data/raw/flags"

const copyText = css`
  color: ${color.main_dark};
  font-size: 0.75em;
  line-height: 1.45em;
  margin-bottom: 0;
  :not(:last-of-type) {
    margin-bottom: 0.5em;
  }
`

const DownloadButton = ({ data, downloadable, contact }) => {
  const buttonStyle = css`
    z-index: 1;
    align-items: center;
    display: inline-flex;
  `

  if (data?.localFiles && data.localFiles.length > 0 && downloadable) {
    return (
      <IconButton
        to={data.localFiles[0].publicURL}
        css={buttonStyle}
        name="Download Project Teaser"
        icon={<DownloadIcon />}
      />
    )
  } else {
    const reason = !downloadable
      ? "No public access available"
      : "Currently not available"
    let button = (
      <IconButtonOff
        name={reason}
        icon={<DownloadIcon />}
        css={[
          css`
            ${buttonStyle}
            &:before {
              background: ${color.main_dark};
              opacity: 0.1;
            }
          `,
        ]}
      />
    )

    return !downloadable &&
      data?.localFiles &&
      data.localFiles.length > 0 &&
      contact &&
      contact.length > 0 ? (
      <div
        css={css`
          background: white;
          padding: 0.5em;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          display: inline-block;
        `}
      >
        {button}
      </div>
    ) : (
      button
    )
  }
}

const Contact = ({ data }) => {
  const buttonStyle = css`
    z-index: 1;
    padding: 0.65em 1.5em;
    display: flex;
    align-items: center;
    &:before {
      background: ${color.main_dark};
    }
    :not(:last-of-type) {
      margin-right: 0.5em;
    }
  `

  return (
    <div
      css={css`
        padding: 1em;
        background: white;
        border-radius: 5px;
        border-top-left-radius: 0;
        display: inline-block;
      `}
    >
      <p
        css={css`
          ${copyText}
          max-width: 45em;
        `}
      >
        Unfortunately this Project Teaser is not available for public access.
        <br />
        If you would like to receive the document in your inbox please address
        your request to {data && data.length > 1 ? "one of the" : ""} the
        Project Teaser contact person{data && data.length > 1 ? "s" : ""}:
      </p>
      {data.map(({ data, recordId }, index) => (
        <div
          key={index}
          css={css`
            background: ${color.accent_light};
            display: flex;
            flex-direction: column;
            border-radius: 5px;
            margin-top: 1em;
            padding: 1em;
            ${mq[0]} {
              flex-direction: row;
              justify-content: space-between;
            }
          `}
        >
          <div
            css={css`
              p {
                margin-bottom: 0;
                line-height: 1;
                &:not(:last-of-type) {
                  margin-bottom: 0.35em;
                }
              }
            `}
          >
            <p
              css={css`
                font-weight: 600;
                font-size: 0.85em;
              `}
            >
              {data.name}
            </p>
            <p
              css={css`
                font-size: 0.75em;
                margin-top: 0.75em;
              `}
            >
              {data.profession}
            </p>
            <p
              css={css`
                font-size: 0.75em;
              `}
            >
              {data.partner_company[0].data.name}
            </p>
          </div>
          <div
            css={css`
              display: flex;
              margin-top: 1em;
              ${mq[0]} {
                margin-left: 2em;
                margin-top: 0;
                align-items: flex-end;
              }
            `}
          >
            <IconButton
              name="Profile"
              icon={<People />}
              to={`/people/${recordId}`}
              css={css`
                ${buttonStyle}
              `}
            />

            {data.mail_public ? (
              <IconButton
                name="eMail"
                icon={<Mail />}
                to={`mailto:${data.email}`}
                css={css`
                  ${buttonStyle}
                `}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export const CSAgendaElement = ({ recordId, data, narrow, className }) => {
  return (
    <div
      className={className}
      css={[
        css`
          background: white;
          border-radius: 5px;
          padding: 1em;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          :not(:last-child) {
            margin-bottom: 0.5em;
          }
          ${mq[1]} {
            flex-direction: row;
            justify-content: space-between;
          }
        `,
        narrow
          ? css`
              ${mq[2]} {
                flex-direction: column;
              }
              ${mq[3]} {
                flex-direction: row;
              }
            `
          : "",
      ]}
    >
      <div
        css={css`
          flex: 0 1 auto;
          margin-right: 1em;
        `}
      >
        <p
          css={css`
            font-weight: 700;
            font-size: 0.65em;
            color: ${color.main_dark};
            margin-bottom: 0.25em;
            display: inline-flex;
            align-items: center;
            ${mq[1]} {
              margin-bottom: 0.5em;
            }
            svg {
              height: 1em;
              width: auto;
              stroke: white;
              margin-right: 0.5em;
            }
          `}
        >
          <span
            css={css`
              white-space: nowrap;
              color: white;
              background: ${color.main_dark};
              border-radius: 5px;
              padding: 0.25em 0.5em;
              margin-right: 0.75em;
              display: inline-flex;
              align-items: center;
            `}
          >
            <Clock />
            {Flags.settings.timezone.autoConversion === true
              ? moment(data.agenda_start_time).format("HH:mm")
              : moment(data.agenda_start_time)
                  .utcOffset(Flags.settings.timezone.offset)
                  .format("HH:mm")}
          </span>
          on {moment(data.agenda_start_time).format("MMMM DD, YYYY")}
          <span
            css={css`
              font-weight: 400;
              margin-left: 1em;
            `}
          >
            ({moment(data.agenda_start_time).utc().format("h:mm A")} UTC)
          </span>
        </p>
        <p
          css={css`
            ${copyText}
            margin-top: .5em;
          `}
        >
          {data.agenda_title}
        </p>
      </div>
      <IconButton
        name={`Open ${narrow ? "" : "Session"} Details`}
        icon={<Calendar />}
        to={passLockFilter(
          `/agenda/${recordFilter(recordId)}`,
          data.password_protected
        )}
        css={[
          css`
            color: ${color.main_dark};
            display: inline-flex;
            align-items: center;
            z-index: 1;
            flex: 0 0 auto;
            margin-top: 1em;
            svg {
              stroke: ${color.main_dark};
            }
            &:before {
              background: ${color.accent_light};
            }
            ${mq[1]} {
              align-self: flex-end;
              margin-top: 0;
            }
          `,
          narrow
            ? css`
                ${mq[2]} {
                  align-self: unset;
                  margin-top: 1em;
                }
                ${mq[3]} {
                  align-self: flex-end;
                  margin-top: 0;
                }
              `
            : "",
        ]}
      />
    </div>
  )
}

const CaseStudy = ({ data, className }) => {
  return (
    <div
      className={className}
      css={css`
        background: ${color.accent_light};
        border-radius: 5px;
        display: flex;
        overflow: hidden;
      `}
    >
      <div
        css={css`
          display: none;
          ${mq[1]} {
            display: block;
            width: calc(100% / 3);
          }
        `}
      >
        {data.cs_thumbnail && data.cs_thumbnail.localFiles.length > 0 ? (
          <GatsbyImage
            alt=""
            image={
              data.cs_thumbnail.localFiles[0].childImageSharp.gatsbyImageData
            }
            css={css`
              height: 100%;
              width: 100%;
            `}
          />
        ) : null}
      </div>

      <div
        css={css`
          padding: 2em 1em;
          ${mq[1]} {
            padding: 2em;
          }
        `}
      >
        <div
          css={css`
            svg {
              height: 1.1em;
              width: auto;
            }
          `}
        >
          <ExpoLogo />
          <div
            css={css`
              margin-bottom: 1.5em;
            `}
          >
            <p
              css={css`
                font-size: 0.9em;
                font-weight: 600;
                color: ${color.main_dark};
                line-height: 1.2em;
                margin-bottom: 0;
              `}
            >
              Project Teaser: EXPO2023
              <span
                css={css`
                  font-size: 0.65em;
                  font-weight: 400;
                  display: block;
                `}
              >
                by STARTUP AUTOBAHN powered by Plug and Play
              </span>
            </p>
          </div>
        </div>
        <h3
          css={css`
            margin-bottom: 0.2em;
            font-size: 1.2em;
            max-width: 85%;
            line-height: 1.4em;
          `}
        >
          {data.cs_title}
        </h3>
        {data.cs_partner && data.cs_partner.length > 0 ? (
          <p
            css={css`
              ${copyText}
              margin-bottom: 1em;
            `}
          >
            in cooperation with the STARTUP AUTOBAHN partner
            {data.cs_partner.length > 1 ? "s" : ""}{" "}
            {data.cs_partner.map((partner, index) => (
              <span key={index}>
                {partner.data.name}
                {index + 1 < data.cs_partner.length ? ", " : ""}
              </span>
            ))}
          </p>
        ) : (
          ""
        )}
        <div
          css={css`
            max-width: 35em;
            p {
              ${copyText}
            }
          `}
          dangerouslySetInnerHTML={{
            __html: data.cs_teaser?.childMarkdownRemark.html,
          }}
        />

        {data.cs_agenda && data.cs_agenda.length > 0 ? (
          <div
            css={css`
              max-width: 45em;
            `}
          >
            <p
              css={css`
                ${copyText}
                margin-top: 1em;
                margin-bottom: 0.75em;
              `}
            >
              This Startup Teaser is also featured in the following session
              {data.cs_agenda.length > 1 ? "s" : ""} on our agenda:
            </p>

            {data.cs_agenda.map(({ data, recordId }, index) => (
              <CSAgendaElement data={data} recordId={recordId} key={index} />
            ))}
          </div>
        ) : (
          ""
        )}

        {Flags.features.casestudy === true && (
          <div
            css={css`
              margin-top: 1.5em;
            `}
          >
            <DownloadButton
              data={data.cs_file}
              downloadable={data.cs_downloadable}
              contact={data.cs_contact}
            />
          </div>
        )}
        {!data.cs_downloadable &&
        data.cs_contact &&
        data.cs_contact.length > 0 ? (
          <Contact data={data.cs_contact} />
        ) : (
          ""
        )}
      </div>
    </div>
  )
}

export default CaseStudy
